

/**
 *
 *
 *
 *
 *
 *
 */
export const assignNamespace = <N, K extends keyof N>(
  parent: N,
  key: K,
  implementation: N[K],
  legacy?: Record<string, unknown>,
): N[K] => {
  /*                                                                                        */
  /*                                                             */
  if (import.meta.env.MODE === "test") {
    parent[key] = Object.assign(parent[key] ?? {}, implementation, legacy);
    return parent[key];
  }

  /*                                                      */
  /*                                                                                           */
  const res = Object.assign(parent[key] ?? {}, implementation, legacy);

  /*                                                                   */
  Object.defineProperty(parent, key, {
    configurable: true,
    enumerable: true,

    /*                                                                           */
    get: () => res,

    /*                                                                                                                  */
    set: (value) => {
      if (typeof value !== "object" || value === null) {
        throw new Error(`Cannot assign non-object value to namespace ${String(key)}`);
      }
      Object.assign(res, value);
    },
  });

  return parent[key];
};
